import { formatSecondsDuration } from 'helpers'
import { connect } from 'react-redux'
import Helmet from './Helmet'

const mapStateToProps = ({ course }) => {
  const title = course?.Course?.Title || ''
  const subtitle = course?.Course?.Subtitle || ''
  const category = course?.Course?.Categories.length ? course.Course.Categories[0].CategorySlug : ''
  const tag = course?.Course?.Tags.length ? course.Course.Tags.join(' ') : ''
  const duration = course?.Course?.Duration ? formatSecondsDuration(course.Course.Duration) : ''
  const image = course.Course?.Image ? course.Course.Image : ''
  const slug = course.Course?.Slug ? course.Course.Slug : ''
  const metaTitle = course?.Course?.MetaTitle || ''
  const metaDescription = course?.Course?.MetaDescription || ''
  return {
    title,
    subtitle,
    category,
    duration,
    tag,
    image,
    slug,
    metaTitle,
    metaDescription
  }
}

export default connect(mapStateToProps, null)(Helmet)
